import React from 'react';
import { Box, Typography, Card, CardContent, CardHeader, Divider, Button } from '@mui/material';
import logoSrc from 'assets/images/newtonxLogo.png';
import srcIcon from 'assets/images/User-Question.png';
import StyledAccordion from '../../../_shared/accordion';
import { useSurveyContent } from '../../../../shared/hooks';
import titleCase from '../../../../shared/helpers/titleCase';
import { surveyPortalMixpanel } from '../../../../vendor/mixpanel';

const Fraud: React.FC = () => {
  const SEID = window.location.pathname.split('/').pop();
  const { surveyContent } = useSurveyContent();
  const source = surveyContent?.survey_host ?? '';
  const environment = process.env.REACT_APP_ENV;
  let suffix = '';
  const survey_id = surveyContent?.survey_id;
  if (environment === 'local' || environment === 'development') {
    suffix = '.dev';
  } else if (environment === 'staging') {
    suffix = '.staging';
  }
  // UTM Sign-up URL
  const signUpUrl = `https://professionals${suffix}.newtonx.com/?utm_source=${source}&utm_medium=survey-experience&utm_campaign=survey-${SEID}&utm_content=fraud-page&utm_term=survey_id_${survey_id}`;
  const userName = surveyContent?.subject_given_name ?? '';
  const reasons = surveyContent?.content?.disqualification_reasons ?? [];
  const hasTrackedRef = React.useRef(false);
  React.useEffect(() => {
    if (!hasTrackedRef.current && surveyContent?.subject) {
      surveyPortalMixpanel.track('Fraud Page Viewed', {
        SSEID: surveyContent?.subject,
        survey_id: surveyContent?.survey_id,
        survey_host: surveyContent?.survey_host,
      });
      hasTrackedRef.current = true;
    }
  }, [surveyContent]);
  const trackUpdateProfile = () => {
    surveyPortalMixpanel.track('Update Profile Button Clicked', {
      SSEID: surveyContent?.subject,
      survey_id: surveyContent?.survey_id,
      survey_host: surveyContent?.survey_host,
      source: 'Survey',
      button_location: 'Fraud page',
    });
  };
  const accordionItems = [
    {
      title: 'Why didn’t I qualify for this survey?',
      content: (
        <>
          <Typography variant="body2" mb="8px">
            Reasons you may not have qualified for this survey include:
          </Typography>
          <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
            {reasons.map((r, i) => (
              <li key={i}>
                <Typography variant="body2">{r}</Typography>
              </li>
            ))}
          </ul>
        </>
      ),
    },
    {
      title: 'Am I going to get paid?',
      content: (
        <Typography variant="body2">
          Because you did not advance beyond the screener, you are not eligible for payment.
        </Typography>
      ),
    },
    {
      title: 'I don’t see my question answered here.',
      content: (
        <Typography variant="body2">
          For any additional questions or issues, get in touch with us via
          professionals@newtonx.com.
        </Typography>
      ),
    },
  ];
  return (
    <Box maxWidth="480px">
      <Typography variant="h2" fontWeight={700} marginBottom="16px">
        {userName && userName.length > 1
          ? titleCase(userName) + ', this survey isn’t quite a fit'
          : 'This survey isn’t quite a fit'}
      </Typography>

      <Typography variant="body1" color="text.secondary" mb="32px">
        We know this isn’t the outcome you were hoping for. We hope we’ll find an opportunity to
        work with you soon.
      </Typography>

      <Typography variant="h3" fontWeight={700} marginBottom="16px">
        Unlock more opportunities!
      </Typography>

      <Typography variant="body1" color="text.secondary" mb="16px">
        Your latest experience helps us find surveys tailored to you. Take a moment to update your
        NewtonX Professionals Community profile—or sign up if you don’t yet have one.
      </Typography>

      <Button
        variant="outlined"
        sx={{ mb: '32px' }}
        fullWidth
        href={signUpUrl}
        component="a"
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackUpdateProfile}
      >
        UPDATE PROFILE
      </Button>

      <Box display="flex" marginBottom="8px">
        <Box
          component={'img'}
          sx={{
            width: '24px',
            height: '24px',
            marginRight: '8px',
          }}
          alt="user_questions"
          src={srcIcon}
        ></Box>
        <Typography variant="h4" fontWeight={700}>
          Frequently Asked Questions
        </Typography>
      </Box>

      <Box>
        <StyledAccordion items={accordionItems}></StyledAccordion>
      </Box>
    </Box>
  );
};

export default Fraud;
